import { Component, Input } from '@angular/core';
import { ButtonType } from '../../../core/types/enums';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [CommonModule, MatIconModule, MatProgressSpinnerModule],
})
export class ButtonComponent {
  @Input() type: ButtonType;
  @Input() text = '';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() withoutLabel = false;
  @Input() action: () => void;
  constructor() {}
}
